import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
type CountryNotice = {
  name: string;
  location: string;
  flag: string;
};
const countryNotices: CountryNotice[] = [{
  name: 'Martina S.',
  location: 'Argentina',
  flag: '🇦🇷'
}, {
  name: 'Valeria M.',
  location: 'Bolivia',
  flag: '🇧🇴'
}, {
  name: 'Camila R.',
  location: 'Chile',
  flag: '🇨🇱'
}, {
  name: 'Santiago P.',
  location: 'Colombia',
  flag: '🇨🇴'
}, {
  name: 'Daniela G.',
  location: 'Costa Rica',
  flag: '🇨🇷'
}, {
  name: 'Lucía A.',
  location: 'Cuba',
  flag: '🇨🇺'
}, {
  name: 'Marcos V.',
  location: 'República Dominicana',
  flag: '🇩🇴'
}, {
  name: 'Ana L.',
  location: 'Ecuador',
  flag: '🇪🇨'
}, {
  name: 'Paola S.',
  location: 'El Salvador',
  flag: '🇸🇻'
}, {
  name: 'Andrea C.',
  location: 'Guatemala',
  flag: '🇬🇹'
}, {
  name: 'Sofía H.',
  location: 'Honduras',
  flag: '🇭🇳'
}, {
  name: 'Diego M.',
  location: 'México',
  flag: '🇲🇽'
}, {
  name: 'Gabriela N.',
  location: 'Nicaragua',
  flag: '🇳🇮'
}, {
  name: 'Carolina P.',
  location: 'Panamá',
  flag: '🇵🇦'
}, {
  name: 'Micaela B.',
  location: 'Paraguay',
  flag: '🇵🇾'
}, {
  name: 'Luis F.',
  location: 'Perú',
  flag: '🇵🇪'
}, {
  name: 'Valentina U.',
  location: 'Uruguay',
  flag: '🇺🇾'
}, {
  name: 'Gabriel T.',
  location: 'Venezuela',
  flag: '🇻🇪'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [noticeIndex, setNoticeIndex] = useState(0);
  const notice = countryNotices[noticeIndex];
  useEffect(() => {
    const showTimer = window.setTimeout(() => setIsVisible(true), 5000);
    return () => window.clearTimeout(showTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) return undefined;
    const rotationTimer = window.setInterval(() => setNoticeIndex(currentIndex => (currentIndex + 1) % countryNotices.length), 6000);
    return () => window.clearInterval(rotationTimer);
  }, [isVisible]);
  return <AnimatePresence mode="wait" data-id="element-150" data-mp="1a2v7eok37sie">{isVisible && <motion.aside key={notice.location} role="status" aria-live="polite" initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-24 left-4 z-40 flex max-w-[290px] items-start gap-3 rounded-2xl border border-brand-green/10 bg-white p-4 pr-9 shadow-xl md:bottom-6 md:left-6" data-id="element-151" data-mp="1h4s3fldraozy"><button type="button" onClick={() => setIsVisible(false)} aria-label="Cerrar notificación de docentes de Latinoamérica" className="absolute right-2 top-2 rounded p-1 text-brand-gray hover:text-brand-greenDark focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-green" data-id="element-152" data-mp="1vug5wpxobtp9"><X className="h-4 w-4" data-id="element-153" data-mp="29swbgdjsve5t" /></button><span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-brand-mint text-brand-green" data-id="element-154" data-mp="29tp82lp1ona8"><CheckCircle2 className="h-5 w-5" aria-hidden="true" data-id="element-155" data-mp="2erqt3c616woc" /></span><div data-id="element-156" data-mp="ffoa031bk4b7"><p className="text-sm font-extrabold text-brand-greenDark" data-id="element-157" data-mp="ffy4a2tecxmp">{notice.name} · {notice.location} {notice.flag}</p><p className="mt-0.5 text-xs font-bold text-brand-green" data-id="element-158" data-mp="kfapyk8j7ynp">Docente de nuestra comunidad</p><p className="mt-1 text-[11px] font-medium text-brand-gray" data-id="element-159" data-mp="cuyq2k6m7zj9">Biología Lista llega a toda LATAM</p></div></motion.aside>}</AnimatePresence>;
}